import React from 'react';

import './styles.scss';
import Modal from 'react-modal';

interface IProps {
	progress: number;
}

const UploadProgress: React.FC<IProps> = ({ progress }) => {
	return (
		<Modal
			isOpen={progress > 0 && progress < 99}
			contentLabel="Add phrase modal"
			className="user-group__modal"
			overlayClassName="user-group__overlay"
		>
			<div className="add-phrase" style={{ height: `50px`, justifyContent: "center" }}>
				Идет загрузка: { progress }%
			</div>
		</Modal>

	);
};

export default UploadProgress;
